
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../../constants';
import request from '../../../../components/Utils/httpHelper';
import {
    CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR,
    createAutomatedOverriddingRiskFactorSuccess,
    createAutomatedOverriddingRiskFactorFailure,
    FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS,
    automatedOveriddingRiskFactorDetailsSuccess,
    automatedOveriddingRiskFactorDetailsFailure,
    EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR,
    editAutomatedOverriddingRiskFactorSuccess,
    editAutomatedOverriddingRiskFactorFailure
} from './action';
import { SCORE_DEFINATION } from '../../../../config';


export function* automatedOveriddingRiskFactorCreate(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/automated`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method:'POST', headers: HTTP_HEADERS });
        yield put(createAutomatedOverriddingRiskFactorSuccess(createResult));
    } catch (err) {
        yield put(createAutomatedOverriddingRiskFactorFailure(err))
    }
}
export function* addAutomatedOveriddingRiskFactor() {
    yield takeLatest(CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR, automatedOveriddingRiskFactorCreate);
}

export function* automatedOveriddingRiskFactorDetails(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/automated/${action.data}`;
    try {
        const fetchResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(automatedOveriddingRiskFactorDetailsSuccess(fetchResult));
    } catch (err) {
        yield put(automatedOveriddingRiskFactorDetailsFailure(err))
    }
}
export function* fetchAutomatedOveriddingRiskFactor() {
    yield takeLatest(FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS, automatedOveriddingRiskFactorDetails);
}

export function* automatedOveriddingRiskFactorEdit(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/automated/${action.data.id}`;
    try {
        const editResult = yield call(request, requestUrl, { data: action.data.requestBody, method:'PUT', headers: HTTP_HEADERS });
        yield put(editAutomatedOverriddingRiskFactorSuccess(editResult));
    } catch (err) {
        yield put(editAutomatedOverriddingRiskFactorFailure(err))
    }
}
export function* editAutomatedOveriddingRiskFactor() {
    yield takeLatest(EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR, automatedOveriddingRiskFactorEdit);
}